$shm_service_task_list $mol_page
	filter? \
	title \Задачи
	add_title \Добавить задачу
	add? null
	add_enabled true
	task_rows /$mol_view
	head /
		<= List_head $shm_list_head
			title <= title
			filter? <=> filter? \
			add? <=> add? null
			add_enabled <= add_enabled
			sort_by? <=> sort_by? \changed
			sort_order? <=> sort_order? \desc
			sort_options <= sort_options *string
				created \Дата создания
				changed \Дата изменения
			sort_content /
				<= Sort
			Close null
	body /
		<= Tasks $mol_list
			rows <= task_rows
	foot /
		<= Add_foot $mol_button_major
			title <= add_title
			enabled <= add_enabled
			click? <=> add? null
	Task_link* $mol_link
		arg <= task_arg* *
		uri_off <= task_uri* \
		title \
		sub /
			<= Task_info* $mol_view
				sub /
					<= Task_title_row* $mol_view
						sub <= task_title_rows* /
					<= Task_meta* $mol_view
						sub / <= task_meta* \
		current <= task_current* false
		event *
			^
			click? <=> task_open*? null
		attr *
			^
			shm_service_task_new <= task_is_new* false
	Task_markers* $mol_view
		sub <= task_marker_rows* /
	Task_title* $mol_view
		sub / <= task_title* \
	Task_row* $mol_view
		attr *
			^
			current <= task_current* false
			archived <= task_archived*? false
			pinned <= task_pinned*? false
		sub /
			<= Task_link*
			<= Task_menu* $shm_service_task_menu
				pin_enabled true
				archive_enabled true
				pinned? <=> task_pinned*?
				archived? <=> task_archived*?
	Empty $mol_view
		sub / \Задач нет
	Sort $shm_sort
		sort_by? <=> sort_by?
		sort_order? <=> sort_order?
		options <= sort_options
	task_arg* *
	task_uri* \
	task_title* \
	task_current* false
	task_open*? null
	task_is_new* false
	task_meta* \
	task_marker_rows* /
	task_title_rows* /
	task_pinned*? false
	task_archived*? false
	sort_by? \changed
	sort_order? \desc
	sort_options *string
		created \Дата создания
		changed \Дата изменения
